import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtils';

import { organizationLoggingStates } from '../../hooks/useOrganizationLoggingHook';

const appInstanceActions = mapDefaultValuesToActions(organizationLoggingStates);

export default reduxReducerHelper(appInstanceActions, organizationLoggingStates);
